import React from "react";
import { FaLinkedin, FaTwitter, FaFacebook } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styles/BoardMembers.css";

import img1 from "../assets/board1.jpg";
import img2 from "../assets/board3.jpg";
import img3 from "../assets/board4.jpg";
import img4 from "../assets/board2.jpg";
import img5 from "../assets/board6.jpg";
import img6 from "../assets/board5.jpg";
import img7 from "../assets/NHRC-board-member.jpg"
import img8 from "../assets/NHRC-Boardmember-3.jpg"

import img9 from  "../assets/RaviTeja.jpg";

const boardMembers = [
  {
    name: "SIVA KRISHNA",
    title1: "National President, NHRC",
    title2: "Manager Director, YSK Infotech",
    image: img1,
    linkedin: "#",
    twitter: "#",
    facebook: "#",
  },
  {
    name: " Sri Rama Ravi Teja Varanasi",
    title1: "Vice President(NHRC)",
    title2: "Head of Talent Acquisitions",
    image: img9,
    linkedin: "#",
    twitter: "#",
    facebook: "#",
  },
  {
    name: "GOVINDA RAJULU PYLA",
    title1: "Executive Advisor (NHRC)",
    title2: "Head HR of KS Bakers.",
    image: img7,
    linkedin: "#",
    twitter: "#",
    facebook: "#",
  },
  {
    name: "PADMA Y",
    title1: "Treasurer (NHRC)",
    title2: " Sr HR VP SVV InfoTech Pvt. Ltd.",
    image: img8,
    linkedin: "#",
    twitter: "#",
    facebook: "#",
  },
  {
    name: "YESWANTH TANGUDU",
    title1: "Trustee (NHRC)",
    title2: " Human Resource Business Partner Jubilant FoodWorks Ltd",
    image: img4,
    linkedin: "#",
    twitter: "#",
    facebook: "#",
  },
  
  {
    name: "RAJASEKHAR",
    title1: "Ex-Officio Member (NHRC)",
    title2: "HR Business Partner, SVV Infotech Pvt Ltd",
    image: img2,
    linkedin: "#",
    twitter: "#",
    facebook: "#",
  },
  
 
  
];

const BoardMembers = () => {
  return (
    <div className="board-section container py-5" id="board-members">
      <h4 className="board-title mb-5 text-center ms-5">OUR BOARD MEMBERS</h4>

      <div className="row justify-content-center g-4">
        {boardMembers.map((member, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-6">
            <div className="card board-card d-flex flex-row align-items-center h-100 mx-auto">
              <img
                src={member.image}
                alt={member.name}
                className="board-image me-3"
              />
                <div className="board-content">

  {/* TEXT FIRST */}
  <div className="board-text">
    <h5 className="board-name mb-1">{member.name}</h5>
    <p className="board-title1 mb-1">{member.title1}</p>
    <p className="board-title2">{member.title2}</p>
  </div>

  {/* ICONS BELOW */}
  <div className="board-icons">
    <a href={member.linkedin} target="_blank" rel="noreferrer">
      <FaLinkedin />
    </a>
    <a href={member.twitter} target="_blank" rel="noreferrer">
      <FaTwitter />
    </a>
    <a href={member.facebook} target="_blank" rel="noreferrer">
      <FaFacebook />
    </a>
  </div>

</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoardMembers;
